'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024107 from "./presto.-Presto-Router$$anon$107.js";
import * as $j_presto$002e$002dSigning$002dPage$0024 from "./presto.-Signing-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$106() {
  this.bcO = null;
  this.bcG = null;
  this.bcH = false;
  this.bcP = null;
  this.bcQ = false;
  this.bcT = null;
  this.bcM = null;
  this.bcN = false;
  this.bcI = null;
  this.bcJ = false;
  this.bcK = null;
  this.bcL = false;
  this.bcR = false;
  this.bcS = false;
  this.bcO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bcT = "SigningPage";
}
export { $c_Lpresto_PrestoRouter$$anon$106 as $c_Lpresto_PrestoRouter$$anon$106 };
$p = $c_Lpresto_PrestoRouter$$anon$106.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$106;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$106() {
}
export { $h_Lpresto_PrestoRouter$$anon$106 as $h_Lpresto_PrestoRouter$$anon$106 };
$h_Lpresto_PrestoRouter$$anon$106.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bcO;
});
$p.M = (function() {
  if ((!this.bcH)) {
    this.bcG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bcH = true;
  }
  return this.bcG;
});
$p.O = (function() {
  if ((!this.bcQ)) {
    this.bcP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bcQ = true;
  }
  return this.bcP;
});
$p.E = (function() {
  return this.bcT;
});
$p.t = (function() {
  if ((!this.bcN)) {
    this.bcM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("token", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bcN = true;
  }
  return this.bcM;
});
$p.N = (function() {
  if ((!this.bcJ)) {
    this.bcI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bcJ = true;
  }
  return this.bcI;
});
$p.Q = (function() {
  if ((!this.bcL)) {
    this.bcK = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024107.$c_Lpresto_PrestoRouter$$anon$107();
    this.bcL = true;
  }
  return this.bcK;
});
$p.v = (function() {
  if ((!this.bcS)) {
    this.bcR = false;
    this.bcS = true;
  }
  return this.bcR;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee638) => ((p) => \u03b4scrutinee638.cFC(p)))($j_presto$002e$002dSigning$002dPage$0024.$m_Lpresto_SigningPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$106 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$106, "presto.PrestoRouter$$anon$106", ({
  ND: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$106 as $d_Lpresto_PrestoRouter$$anon$106 };
//# sourceMappingURL=presto.-Presto-Router$$anon$106.js.map
